import { badgeProgression } from "@bbb/model";
import { BadgeTierUI, ViewTypes } from "@types";
import { Crown, Hammer, Shield, Sparkles, UserIcon } from "lucide-react";

const badgeIconById = {
  normie: UserIcon,
  builder: Hammer,
  architect: Sparkles,
  og: Shield,
  ambassador: Crown,
} as const;

const badgeGradientById = {
  normie: "from-slate-500 to-slate-600",
  builder: "from-blue-500 to-cyan-600",
  architect: "from-purple-500 to-pink-600",
  og: "from-emerald-500 to-teal-600",
  ambassador: "from-yellow-500 to-amber-600",
} as const;

const badgeTextColorById = {
  normie: "text-slate-100",
  builder: "text-white",
  architect: "text-white",
  og: "text-white",
  ambassador: "text-white",
} as const;

const badgeGlowColorById = {
  normie: "shadow-slate-500/20",
  builder: "shadow-blue-500/30",
  architect: "shadow-purple-500/30",
  og: "shadow-emerald-500/30",
  ambassador: "shadow-yellow-500/40",
} as const;

export const BADGE_TIERS: BadgeTierUI[] = badgeProgression.map((badge) => ({
  id: badge.id,
  name: badge.badgeTier,
  minBlocks: badge.minBlocks,
  maxBlocks: badge.maxBlocks,
  icon: badgeIconById[badge.id],
  gradient: badgeGradientById[badge.id],
  textColor: badgeTextColorById[badge.id],
  glowColor: badgeGlowColorById[badge.id],
}));

export const protectedViews: ViewTypes[] = [
  "profile-settings",
  "active-quests",
  "referrals",
  "rewards-hub",
  "ambassador-hub",
  "create-community",
  "community-admin",
  "achievements",
];
